// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"393":"187aba6e","453":"f69089c5","459":"8fd940b9"}[chunkId] + ".chunk.js";
};